import React from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

class Header extends React.Component {
  render () {
    return (
      <header className="header__container">
        <Link to="/" className="header-title">Lorem Ipsum</Link>
          <nav className="header-navbar">
            <ul className="header-navbar__list">
              <li className="header-navbar__item moreinfo">
                <Link to="/registro">Registro</Link>
              </li>
              <li className="header-navbar__item circulos">
                <Link to="/circulos">Círculos</Link>
              </li>
              <li className="header-navbar__item desplegable">
                <Link to="/desplegable">Desplegable</Link>
              </li>
              <li className="header-navbar__item como-soy">
                <Link to="/contacto">Contacto</Link>
              </li>
            </ul>
          </nav>
      </header>
    )
  }
}

export default Header;
